@if (showTrigger()) {
<button type="button" class="btn-fab-primary cursor-pointer" #screeningDetailsDrawerButton command="show-modal"
    [attr.commandfor]="dialogId" (click)="onDrawerOpen()" aria-label="Open screening details">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
    </svg>
</button>
}

<el-dialog>
    <dialog #screeningDetailsDrawerDialog [id]="dialogId" [attr.aria-labelledby]="dialogId + '-title'"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 focus:outline-none z-20" (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block h-full w-2/3 transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full min-h-0 flex-col overflow-hidden shadow-xl rounded-xl">

                    <div class="flex h-full min-h-0 flex-col overflow-hidden divide-y divide-border">

                        <!-- header -->
                        <div class="shrink-0 px-2 py-4 drawer-header-primary">
                            <div class="flex space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2">
                                    <p class="text-md font-semibold text-primary" [id]="dialogId + '-title'">
                                        Screening Details
                                    </p>
                                    <p class="text-sm text-secondary">
                                        See how this piece of content was screened.
                                    </p>
                                </div>

                                <div class="h-full flex flex-col justify-between items-end">

                                    <button type="button" (click)="closeDrawer()"
                                        class="btn-fab-secondary text-secondary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden drawer-body-primary divide-y divide-border">
                            <div class="grid h-full min-h-0 w-full grid-cols-2 gap-2">
                                <div class="col-span-1 flex h-full min-h-0 w-full items-center justify-center p-2">
                                    <div class="flex h-full min-h-0 w-full items-center justify-center overflow-hidden rounded-lg border border-border">
                                        @if (content.mediaKind === 'image') {
                                        <img class="h-auto max-h-full w-auto max-w-full object-contain" [src]="content.contentUrls[0]"
                                            [alt]="content.contentUrl" />
                                        } @else if (content.mediaKind === 'video') {
                                        <video class="h-auto max-h-full w-auto max-w-full object-contain" [src]="content.contentUrls[0]"
                                            controls playsinline preload="metadata"></video>
                                        } @else if (content.mediaKind === 'carousel') {
                                        <div class="grid h-full min-h-0 w-full auto-rows-fr grid-cols-2 gap-2">
                                            @for (url of content.contentUrls; track url) {
                                            <div class="flex min-h-0 min-w-0 items-center justify-center">
                                                <img class="h-auto max-h-full w-auto max-w-full object-contain" [src]="url"
                                                    [alt]="content.contentUrl" />
                                            </div>
                                            }
                                        </div>
                                        } @else {
                                        <div class="flex h-full w-full items-center justify-center">
                                            <p class="m-0 text-sm text-secondary">No media</p>
                                        </div>
                                        }
                                    </div>
                                </div>
                                <div class="col-span-1 h-full min-h-0 w-full p-2">
                                    <div class="h-full w-full rounded-lg overflow-hidden border border-border">
                                        @if (loadingState() === 'loading') {
                                        <div class="flex h-full w-full items-center justify-center p-4">
                                            <p class="text-sm text-secondary">Loading screening results</p>
                                        </div>
                                        } @else if (screeningResults()) {
                                        <atom-individual-post-ai-review class="h-full w-full" [reviewHistory]="screeningResults()" [resultsOnly]="true">
                                        </atom-individual-post-ai-review>
                                        } @else {
                                        <div class="flex h-full w-full items-center justify-center p-4">
                                            <p class="text-sm text-secondary">No screening results</p>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- main content - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>